/* eslint-disable react/display-name */
import React from 'react';
import { SvgIcon } from './SvgIcon.js';
import type { SvgIconT } from './react-desc-prop-types.js';

interface CreateIconT {
  paths: SvgIconT.Props['paths'];
  height: number;
  width: number;
  containerProps?: SvgIconT.Props;
}

export const createIcon = ({ containerProps = {}, paths, height, width }: CreateIconT) => {
  const Comp = (rest: SvgIconT.Props) => (
    <SvgIcon {...rest} {...containerProps} paths={paths} viewBox={`0 0 ${width} ${height}`} />
  );
  return Comp;
};

export default createIcon;
